import { memo } from 'react';
import Card from '@raydiant/raydial/components/Card';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';

interface QuickStartGuideItemProps {
  title: string;
  description: string;
  imgSrc: string;
  buttonLabel: string;
  onClick: () => void;
}

const QuickStartGuideItem = ({
  title,
  description,
  imgSrc,
  buttonLabel,
  onClick,
}: QuickStartGuideItemProps) => {
  return (
    <Card className="border border-gray-200 p-6 flex flex-col gap-2.5">
      <div className="flex gap-4">
        <img className="w-11 h-12 shrink-0" src={imgSrc} alt={title} />

        <div className="flex flex-col gap-2 text-black">
          <Text className="font-bold" variant="body">
            {title}
          </Text>
          <Text variant="body">{description}</Text>
        </div>
      </div>
      <Button variant="primary" onPress={onClick}>
        {buttonLabel}
      </Button>
    </Card>
  );
};

export default memo(QuickStartGuideItem);
